import React, { useState } from "react";
import "../css/Common.css";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";

const Footer = () => {
  const [dropdown1, setDropdown1] = useState(false);
  const [dropdown2, setDropdown2] = useState(false);
  const [dropdown3, setDropdown3] = useState(false);
  return (
    <>
      <div className="footer_wrapper full-width">
       
        <div className="copyright_section mt30">
          <p>
            Copyright © RBI Registered NBFC Baid Stock Broking Services Private Limited
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
